// Copyright (C) 2020 One More Game - All Rights Reserved
// Unauthorized copying of any files within this project, via any medium, is strictly prohibited
// Proprietary and confidential

import React, { useState } from "react"
import { Link } from "gatsby"
import * as styles from "./styles.module.scss"

const NavLink = ({ to, children }) => {
  return (
    <li className={styles.navListItem}>
      <Link to={to}>{children}</Link>
    </li>
  )
}

const NavList = ({ children, isOpen }) => {
  return (
    <div
      className={`${styles.container} ${isOpen ? styles.containerOpen : ""}`}
    >
      <ul id="menu-main-navigation" className={styles.navList}>
        {children}
      </ul>
    </div>
  )
}

const HamburgerBtn = ({ isOpen, toggleFn }) => {
  // This is an 'odd' way to put a Hamburger menu together but it works. The three
  // italic elements form the three lines of the menu. When they're clicked, the
  // stylesheet animates the top and bottom lines to rotate into an 'X' and hides
  // the center line.
  return (
    <label
      className={`${styles.toggle} ${isOpen ? styles.open : ""}`}
      onClick={toggleFn}
    >
      <i></i>
      <i></i>
      <i></i>
    </label>
  )
}

const NavBar: React.FC = () => {
  const [isOpen, setOpen] = useState(false)

  const toggleOpen = () => {
    setOpen(!isOpen)
  }

  return (
    <nav role="navigation">
      <HamburgerBtn isOpen={isOpen} toggleFn={toggleOpen} />
      <NavList isOpen={isOpen}>
        <NavLink to="/">Home</NavLink>
        <NavLink to="/about-us">About us</NavLink>
        <NavLink to="/careers">Careers</NavLink>
        <NavLink to="/press">Press</NavLink>
        <NavLink to="/blog">Blog</NavLink>
        <NavLink to="/games">Games</NavLink>
      </NavList>
    </nav>
  )
}

export default NavBar
